import React from 'react';
import {Redirect, Route} from "react-router-dom";

export function Routes(routes, redirectTo = '') {
    const routeDivs = routes.map(({ path, component }) => (
        <Route exact path={path} component={component} key={path} />
    ));

    if (redirectTo) {
        routeDivs.push(
            <Redirect to={{pathname: redirectTo}} key={routeDivs.length} />,
        );
    }
    return routeDivs;
}
